import { render, staticRenderFns } from "./SubmitDocumentModal.vue?vue&type=template&id=34917385"
import script from "./SubmitDocumentModal.vue?vue&type=script&lang=js"
export * from "./SubmitDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports